function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheck01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h13v18H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m-6258.424-3278.51 3.681 4.571 6.437-9.723",
  "data-name": "Path 506",
  style: {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  },
  transform: "translate(6260 3287.801)"
}));
export default SvgIconCheck01;